import styled from "@yb/styled-px2rem";

const GuideText = styled.p`
	position: relative;
	padding-left: 15px;
	margin-top: 15px;
	font-size: 15px;
	color: var(--default-color);

	&::before {
		position: absolute;
		top: 9px;
		left: 0;
		display: block;
		width: 4px;
		height: 4px;
		border-radius: 50%;
		background: var(--bl-color);
		content: "";
	}
`;

export default GuideText;
